<template>
    <div class="homepage">
        <div class="profile-header">
            <div class="avatar" @click="chooseImage">
                <img v-if="userInfo.img" :src="userInfo.img" class="avatar-img" />
                <van-icon v-else name="user-circle-o" size="32" color="#1565C0" />
            </div>
            <div class="profile-info">
                <div class="profile-name" @click="editUserName">{{ userInfo.name }}<van-icon name="edit"
                        class="edit-icon" /></div>
                <div class="profile-username">{{ userInfo.account }}</div>
            </div>

            <van-popup v-model="showEditNamePopup" position="center" round>
                <div class="popup-content">
                    <h3>编辑用户名</h3>
                    <van-field v-model="editName" placeholder="请输入新的用户名" maxlength="20" />
                    <div class="popup-buttons">
                        <van-button type="default" @click="showEditNamePopup = false">取消</van-button>
                        <van-button type="primary" @click="updateUserName" style="background: #1565C0;">确定</van-button>
                    </div>
                </div>
            </van-popup>
        </div>

        <div class="stats-row">
            <div class="stat-item">
                <div class="stat-value">{{ summaryData.reportCount }}</div>
                <div class="stat-label">企业数量</div>
            </div>
            <div class="stat-item stat-item-center">
                <div class="stat-value">{{ summaryData.loanCount }}</div>
                <div class="stat-label">贷后记录</div>
            </div>
            <div class="stat-item">
                <div class="stat-value">{{ summaryData.unreadMessageCount }}</div>
                <div class="stat-label">未读消息</div>
            </div>
        </div>

        <div class="menu-card">
            <div v-for="(item, index) in menuItems" :key="item.id" class="menu-item"
                :class="{ 'menu-item--last': index === menuItems.length - 1 }" @click="onMenuClick(item)">
                <div class="menu-icon-wrap" :style="{ backgroundColor: item.color + '15' }">
                    <van-icon :name="item.vanIcon" size="18" :color="item.color" />
                </div>
                <span class="menu-label" :class="{ 'menu-label--danger': item.id === 'logout' }">{{ item.label }}</span>
                <div class="menu-right">
                    <span v-if="item.id === 'message' && summaryData.unreadMessageCount > 0" class="badge">{{
                        summaryData.unreadMessageCount }}</span>
                    <van-icon v-if="item.id !== 'logout'" name="arrow" class="menu-arrow" />
                </div>
            </div>
        </div>

        <div class="sms-card">
            <div class="sms-row">
                <div class="menu-icon-wrap" style="background-color: rgba(0, 137, 123, 0.08)">
                    <van-icon name="comment-o" size="18" color="#00897B" />
                </div>
                <span class="sms-label">短信到期提醒</span>
                <van-switch v-model="smsReminderEnabled" size="22px" active-color="#1566C1" @change="onSmsToggle" />
            </div>
            <div v-if="smsReminderEnabled" class="sms-phone-row">
                <span class="sms-phone-label">接收手机号</span>
                <span class="sms-phone-value">{{ smsPhone || '未绑定' }}</span>
                <van-button size="mini" plain type="info" @click="showPhonePopup = true" class="sms-phone-btn">{{ smsPhone ? '修改' : '绑定' }}</van-button>
            </div>
        </div>

        <van-popup v-model="showPhonePopup" position="center" round class="phone-popup">
            <div class="phone-popup-content">
                <h3>绑定手机号</h3>
                <van-field v-model="editPhone" placeholder="请输入11位手机号" type="tel" maxlength="11" />
                <div class="popup-buttons">
                    <van-button type="default" @click="showPhonePopup = false">取消</van-button>
                    <van-button type="primary" @click="submitSmsReminder(true)" :loading="smsSubmitting" style="background: #1565C0;">确定</van-button>
                </div>
            </div>
        </van-popup>

        <van-tabbar v-model="active">
            <van-tabbar-item to="/credit/home" icon="edit">录入</van-tabbar-item>
            <van-tabbar-item icon="contact">我的</van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script>
import { user } from "@/store/index";
import { mapState } from "pinia";
import useCache from "@/utils/user";
import { Toast } from 'vant';
import request from "@/utils/request";

export default {
    data() {
        return {
            active: 1,
            summaryData: {
                reportCount: 0,
                loanCount: 0,
                unreadMessageCount: 0
            },
            showEditNamePopup: false,
            editName: '',
            smsReminderEnabled: false,
            smsPhone: '',
            showPhonePopup: false,
            editPhone: '',
            smsSubmitting: false,
            menuItems: [
                { id: 'enterprise', vanIcon: 'records-o', label: '企业管理', route: '/credit/enterpriseManage?t=0', color: '#1565C0' },
                { id: 'loan-enterprise', vanIcon: 'balance-list-o', label: '企业贷后', route: '/credit/customerManage?loanType=1', color: '#00897B' },
                { id: 'loan-personal', vanIcon: 'balance-list-o', label: '个人贷后', route: '/credit/customerManage?loanType=0', color: '#00897B' },
                { id: 'invite', vanIcon: 'share-o', label: '邀请好友', route: '/credit/invite', color: '#1566C1' },
                { id: 'message', vanIcon: 'bell', label: '消息管理', route: '/credit/message', color: '#F57C00' },
                { id: 'password', vanIcon: 'lock', label: '修改密码', route: '/credit/changePassword?source=credit', color: '#7B1FA2' },
                { id: 'logout', vanIcon: 'revoke', label: '退出登录', route: null, color: '#C62828' },
            ],
        }
    },
    created() {
        this.getMySummary();
        this.loadSmsState();
    },
    computed: {
        ...mapState(user, ["userInfo"]),
    },
    methods: {
        onMenuClick(item) {
            if (item.id === 'logout') {
                this.handleLogOut()
            } else if (item.route) {
                this.$router.push(item.route)
            }
        },
        getMySummary() {
            request.get('/Common/Dashboard/MySummary')
                .then((res) => {
                    if (res.data && res.data.data) {
                        this.summaryData = res.data.data;
                    }
                })
                .catch((error) => {
                    console.error('获取汇总数据失败:', error);
                });
        },
        handleLogOut() {
            Toast("退出登录成功");
            useCache.clearToken();
            this.$router.replace({
                path: '/credit/login',
                query: { source: 'credit' }
            })

        },
        chooseImage() {
            const input = document.createElement('input');
            input.type = 'file';
            input.accept = 'image/*';
            input.onchange = (e) => {
                const file = e.target.files[0];
                if (file) {
                    this.uploadLocalImage({ file });
                }
            };
            input.click();
        },
        uploadLocalImage(file) {
            Toast.loading({
                message: '正在上传...',
                forbidClick: true,
            });

            const formData = new FormData();
            formData.append('id', 0);
            formData.append('file', file.file);

            request.post("/Common/File/UploadFile", formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then((res) => {
                Toast.clear();
                if (res.data && res.data.data) {
                    this.updateUserImg(process.env.VUE_APP_BASE_API.replace('/api', '') + res.data.data)
                } else {
                    Toast('头像更新失败，请重试');
                }
            }).catch((error) => {
                Toast.clear();
                console.error('保存图片失败:', error);
                Toast('头像更新失败，请重试');
            });
        },
        editUserName() {
            this.editName = this.userInfo.name || '';
            this.showEditNamePopup = true;
        },
        updateUserName() {
            if (!this.editName.trim()) {
                Toast('请输入用户名');
                return;
            }

            Toast.loading({
                message: '正在更新...',
                forbidClick: true,
            });

            request.post("/User/AccountMng/UpdateMyInfo", {
                name: this.editName.trim(),
                img: this.userInfo.img || ''
            }).then((res) => {
                Toast.clear();
                if (res.data && res.data.code === 0) {
                    this.userInfo.name = this.editName.trim();

                    useCache.cacheUserData(this.userInfo)
                    Toast('用户名更新成功');
                    this.showEditNamePopup = false;
                } else {
                    Toast('用户名更新失败，请重试');
                }
            }).catch((error) => {
                Toast.clear();
                console.error('更新用户信息失败:', error);
                Toast('用户名更新失败，请重试');
            });
        },
        loadSmsState() {
            request.get('/User/AccountMng/GetUserInfo').then((res) => {
                if (res.data && res.data.data) {
                    this.smsReminderEnabled = !!res.data.data.smsReminderEnabled;
                    const account = res.data.data.account || '';
                    this.smsPhone = /^1\d{10}$/.test(account) ? account : '';
                }
            }).catch(() => {});
        },
        onSmsToggle(val) {
            if (val) {
                const account = this.userInfo.account || '';
                if (/^1\d{10}$/.test(account)) {
                    this.smsPhone = account;
                    this.submitSmsReminder(true);
                } else {
                    this.editPhone = '';
                    this.showPhonePopup = true;
                }
            } else {
                this.submitSmsReminder(false);
            }
        },
        submitSmsReminder(enabled) {
            const phone = enabled ? (this.editPhone.trim() || this.smsPhone) : this.smsPhone;
            if (enabled && !/^1\d{10}$/.test(phone)) {
                Toast('请输入正确的11位手机号');
                this.smsReminderEnabled = false;
                return;
            }
            this.smsSubmitting = true;
            request.post('/User/AccountMng/UpdateSmsReminder', {
                smsReminderEnabled: enabled,
                phone: phone,
            }).then((res) => {
                if (res.data && res.data.code === 0) {
                    this.smsReminderEnabled = enabled;
                    if (enabled) this.smsPhone = phone;
                    this.showPhonePopup = false;
                    Toast(enabled ? '短信提醒已开启' : '短信提醒已关闭');
                } else {
                    this.smsReminderEnabled = !enabled;
                    Toast(res.data.msg || '操作失败');
                }
            }).catch(() => {
                this.smsReminderEnabled = !enabled;
                Toast('操作失败，请重试');
            }).finally(() => {
                this.smsSubmitting = false;
            });
        },
        updateUserImg(filePath) {
            Toast.loading({
                message: '正在更新...',
                forbidClick: true,
            });

            request.post("/User/AccountMng/UpdateMyInfo", {
                name: this.userInfo.name,
                img: filePath
            }).then((res) => {
                Toast.clear();
                if (res.data && res.data.code === 0) {
                    this.userInfo.img = filePath;

                    useCache.cacheUserData(this.userInfo)
                    Toast('头像更新成功');
                } else {
                    Toast('头像更新失败，请重试');
                }
            }).catch((error) => {
                Toast.clear();
                console.error('更新用户信息失败:', error);
                Toast('用户名更新失败，请重试');
            });
        }
    }
}
</script>

<style lang="less" scoped>
.homepage {
    background: #F0F4FF;
    padding: 16px 16px;
    min-height: 100vh;
    color-scheme: light;
    -webkit-color-scheme: light;
}

.profile-header {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 24px;
    margin: 0;
    border-radius: 20px;
    background: linear-gradient(135deg, #0D47A1 0%, #1565C0 50%, #1976D2 100%);
}

.avatar {
    width: 72px;
    height: 72px;
    flex-shrink: 0;
    border-radius: 50%;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 3px solid rgba(255, 255, 255, 0.4);
    overflow: hidden;
}

.avatar-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.profile-info {
    flex: 1;
    min-width: 0;
}

.profile-name {
    font-size: 22px;
    font-weight: 700;
    color: #fff;
    margin-bottom: 2px;
    line-height: 1.2;
}

.profile-username {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.75);
    margin-bottom: 8px;
    line-height: 1.2;
}

.vip-badge {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 20px;
    padding: 4px 10px;
    border: 1px solid rgba(255, 215, 0, 0.4);
    font-size: 12px;
    font-weight: 600;
    color: #FFD700;
}

.stats-row {
    display: flex;
    background: #fff;
    margin: 16px 0px;
    border-radius: 16px;
    padding: 16px 0;
    box-shadow: 0 4px 12px rgba(21, 101, 192, 0.12);
}

.stat-item {
    flex: 1;
    text-align: center;
    padding: 4px 0;
}

.stat-item-center {
    border-left: 1px solid #EEF1FA;
    border-right: 1px solid #EEF1FA;
}

.stat-value {
    font-size: 22px;
    font-weight: 700;
    color: #1565C0;
    margin-bottom: 2px;
    line-height: 1.2;
}

.stat-label {
    font-size: 12px;
    color: #5B6B8A;
    line-height: 1.2;
}

.menu-card {
    background: #fff;
    margin-top: 16px;
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 4px 16px rgba(21, 101, 192, 0.12);
}

.sms-card {
    background: #fff;
    margin-top: 16px;
    margin-bottom: 60px;
    border-radius: 20px;
    padding: 16px 20px;
    box-shadow: 0 4px 16px rgba(21, 101, 192, 0.12);
}

.sms-row {
    display: flex;
    align-items: center;
    gap: 14px;
}

.sms-label {
    flex: 1;
    font-size: 15px;
    font-weight: 500;
    color: #0D1B3E;
}

.sms-phone-row {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 14px;
    padding: 10px 14px;
    background: #F5F7FF;
    border-radius: 12px;
}

.sms-phone-label {
    font-size: 13px;
    color: #5B6B8A;
}

.sms-phone-value {
    flex: 1;
    font-size: 14px;
    font-weight: 500;
    color: #0D1B3E;
    text-align: right;
}

.sms-phone-btn {
    flex-shrink: 0;
    border-color: #1566C1;
    color: #1566C1;
}

.menu-item {
    display: flex;
    align-items: center;
    padding: 16px 20px;
    gap: 14px;
    cursor: pointer;
    transition: background 0.15s;
    border-bottom: 1px solid #EEF1FA;
}

.menu-item:hover {
    background: #F5F7FF;
}

.menu-item--last {
    border-bottom: none;
}

.menu-icon-wrap {
    width: 38px;
    height: 38px;
    flex-shrink: 0;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.menu-label {
    flex: 1;
    font-size: 15px;
    font-weight: 500;
    color: #0D1B3E;
    text-align: left;
}

.menu-label--danger {
    color: #C62828;
}

.menu-right {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
}

.menu-arrow {
    color: #9DAAC0;
    font-size: 16px;
}

.badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 20px;
    height: 20px;
    padding: 0 6px;
    border-radius: 10px;
    background: #C62828;
    color: #fff;
    font-size: 11px;
    font-weight: 700;
}

.cell-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}

.unread-badge {
    background-color: #ff4444;
    color: #ffffff;
    font-size: 0.7rem;
    padding: 0.1rem 0.4rem;
    border-radius: 180px;
    min-width: 1.0rem;
    text-align: center;
    margin-left: 0.5rem;
}

:deep(.van-cell-group) {
    background: #ffffff;
}

:deep(.van-cell) {
    background: #ffffff;
    color: #333;
}

:deep(.van-tabbar) {
    background: #ffffff;
}

:deep(.van-tabbar-item) {
    color: #666;
}

:deep(.van-tabbar-item--active) {
    color: #3a71ff;
}

::v-deep .phone-popup {
    width: 85vw;
    max-width: 340px;
    overflow: hidden;
}

.phone-popup-content {
    padding: 24px;
}

.phone-popup-content h3 {
    margin: 0 0 16px 0;
    font-size: 18px;
    font-weight: 600;
    color: #333;
    text-align: center;
}

.popup-content {
    padding: 24px;
    width: 90%;
    min-width: 250px;
}

.popup-content h3 {
    margin: 0 0 20px 0;
    font-size: 18px;
    font-weight: 600;
    color: #333;
    text-align: center;
}

.popup-buttons {
    display: flex;
    gap: 12px;
    margin-top: 24px;
}

.popup-buttons .van-button {
    flex: 1;
}

.profile-name {
    cursor: pointer;
    transition: opacity 0.2s;
    display: flex;
    align-items: center;
    gap: 8px;
}

.profile-name:hover {
    opacity: 0.8;
}

.edit-icon {
    font-size: 16px;
    color: rgba(255, 255, 255, 0.85);
}
</style>
